import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {Project} from '@libs-classes/project.class';
import {ProjectService} from '@lib-services/project.service';
import {IProject, IProjectCreate, IProjectUpdate} from '@lib-typing/project.interface';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {CommonDropdownComponent} from '@lib-ui/common-dropdawn/common-dropdown.component';
import {MessageService} from '@lib-services/message.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {filter, switchMap} from 'rxjs';
import { CloseButtonComponent } from '@lib-ui/close-button/close-button.component';

@Component({
    selector: 'app-project-editor',
    standalone: true,
    imports: [
        CommonModule,
        MatButton,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        CommonDropdownComponent,
        MatDialogContent,
        MatDialogActions,
        LoaderComponent,
        CloseButtonComponent,
        MatDialogTitle,
    ],
    templateUrl: './project-editor.component.html',
    styleUrl: './project-editor.component.scss'
})
export class ProjectEditorComponent implements OnInit {
    project = new Project({} as IProject);
    loading = signal(false);

    readonly dialogRef = inject(MatDialogRef<ProjectEditorComponent>);
    readonly fb = inject(FormBuilder);
    readonly projectService = inject(ProjectService);
    protected messagesService = inject(MessageService);
    // protected companySelectorService = inject(CompanySelectorService);
    public data: { projectId?: number } = inject(MAT_DIALOG_DATA);

    projectForm= this.fb.group({
        name: ['', Validators.required],
        // companyId: [0, Validators.required],
    });

    ngOnInit(): void {
        if (this.data.projectId) {
            this.loading.set(true);
            this.projectService.getProject(this.data.projectId).subscribe( {
                next: data => {
                    this.project.data = data;
                    this.projectForm.setValue(this.project.formData());
                },
                error: error => {this.messagesService.errorMessage(error.message);}
            }).add(() => this.loading.set(false));
        }
    }

    onSubmit(): void {
        if (!this.projectForm.valid) {
            return;
        }

        this.loading.set(true);
        const request = this.project.data.id
            ? this.projectService.updateProject(this.project.dataForUpdate(this.projectForm.value as IProjectUpdate))
            :  this.projectService.createProject(this.project.dataForCreate(this.projectForm.value as IProjectCreate));

        request.subscribe({
            next: result => {
                this.messagesService.successMessage('Проект успешно сохранен');
                this.dialogRef.close(result);},
            error: error => {this.messagesService.errorMessage(error.message);}
        }).add(() => this.loading.set(false));
    }

    deleteProject(id: number): void {
        if(!this.project.data) {return;}

        this.messagesService.confirmMessage({
            title: 'Удаление проекта',
            text: 'Вы действительно хотите удалить проект?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.projectService.deleteProjects([id]);
            }),
        ).subscribe({
            next: () => {
                this.messagesService.successMessage('Проект успешно удален');
                this.dialogRef.close(true);
            },
            error: () => this.messagesService.errorMessage('При удалении произошла ошибка')
        });
    }
}
